import SelectionState from "state/selections/SelectionState";
import { COMMIT_SELECTIONS } from "state/selections/actions";
import {SET_DEFINITIONS} from "./actions";
import { Record } from "immutable";
const Selections = Record({
  columnDef: [],
});
const State = Record({
  [SelectionState.COMMITTED]: new Selections(),
  [SelectionState.UNCOMMITTED]: new Selections()
})

export default (state = new State(), action) => {
  switch (action.type) {
    case SET_DEFINITIONS:
      return state.setIn(
        [SelectionState.UNCOMMITTED, "columnDef"],
        action.columnDef
      );
    case COMMIT_SELECTIONS:
      return state.set(
        SelectionState.COMMITTED,
        state[SelectionState.UNCOMMITTED]
      );
    default:
      return state;
  }
};
